import React from "react";
import { motion } from "framer-motion";

// Scroll-triggered fade/slide-up entrance, used instead of hand-rolling the same
// framer-motion props on every section. Animates once, the first time it enters
// the viewport, so re-scrolling past a section doesn't replay the animation.
const Reveal = ({
  children,
  as = "div",
  delay = 0,
  y = 16,
  duration = 0.45,
  className = "",
  once = true,
  amount = 0.2,
  ...props
}) => {
  const Component = motion[as] || motion.div;
  return (
    <Component
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, amount }}
      transition={{ duration, delay, ease: "easeOut" }}
      className={className}
      {...props}
    >
      {children}
    </Component>
  );
};

// Wraps a list of children and staggers their entrance. Give each direct child
// item the `revealItem` variant (exported below) instead of nesting more <Reveal>s.
export const RevealGroup = ({ children, stagger = 0.08, className = "", once = true, amount = 0.2, ...props }) => (
  <motion.div
    initial="hidden"
    whileInView="visible"
    viewport={{ once, amount }}
    variants={{ visible: { transition: { staggerChildren: stagger } } }}
    className={className}
    {...props}
  >
    {children}
  </motion.div>
);

export const revealItem = {
  hidden: { opacity: 0, y: 16 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.4, ease: "easeOut" } },
};

export default Reveal;
